import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';

const Dev = () => {
    const navigate = useNavigate();
    
    // Redux state
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    // Auth check
    useEffect(() => {
        if (!userInfo) {
            navigate('/login');
        }
        if(userInfo && !userInfo.isAdmin) {
            navigate('/dashboard');
        }
    }, [userInfo, navigate]);

    return (
        <Layout title={"Development"} col>
            <div className="text-center text-white">
                <p>Development page - ready for new features</p>
            </div>
        </Layout>
    );
};

export default Dev;
